import { PRIVATE_BASE_URL } from 'configs'
import { customResponseParser, logoutOnRequestOrResponseJson } from 'api'

export interface SchemaReferenceUploadResponse {
  ok: boolean
  version?: string
  counts?: Record<string, number>
  errors?: string[]
}

export const uploadSchemaReference = (file: File): Promise<SchemaReferenceUploadResponse> => {
  const formData = new FormData()
  formData.append('file', file)

  return fetch(`${PRIVATE_BASE_URL}/dataset/schema-reference`, {
    credentials: 'include',
    method: 'POST',
    body: formData,
  })
    .then(response => logoutOnRequestOrResponseJson(response))
    .then(response => customResponseParser(response))
}
